import { AnchorButton, H5 } from '@blueprintjs/core';
import React from 'react';

export default function Login() {
  return (
    <div >
      <H5 style={{textAlign: "center"}}>Login with</H5>
      <div style={{display: "flex", justifyContent: "center"}}>
        <AnchorButton href={process.env.REACT_APP_DISCORD_OAUTH2_URL} icon={<img src={`${process.env.REACT_APP_API_BASE_URL}/discord.png`} style={{width: "15px"}} />} text="Discord"/>
      </div>
    </div>
  );
}